/* eslint-disable no-alert */
import React from 'react'
import moment from 'moment'
import { reduce, get, map } from 'lodash'
import { Modal, Header, Form, Button, Input } from 'semantic-ui-react'
import firebase from '../../../../config/firebase'

import DateField from '../../../../components/promotions/fields/dateField'
import BranchesField from '../../../../components/promotions/fields/branchesField'
import RestaurantsField from '../../../../components/promotions/fields/restaurantField'

export default class QtyPromotionForm extends React.PureComponent {
  state = {
    title: '',
    saving: false,
    selectedBranchId: null,
    endedAt: Date.now(),
    startedAt: Date.now(),
    selectedMerchant: null,
    isApplyToAllBranches: false,
  }

  componentDidMount() {
    const { promotion } = this.props

    if (promotion) {
      this.setState({
        title: promotion.title,
        endedAt: promotion.ended_at,
        startedAt: promotion.started_at,
        selectedBranchId: promotion.branch_id,
        selectedMerchant: promotion.merchant_id,
      })
    }
  }

  validateFields = () => {
    const { title, selectedBranchId, selectedMerchant, startedAt, endedAt, isApplyToAllBranches } = this.state

    return new Promise((resolve, reject) => {
      if (title.length === 0) {
        reject(Error('Title cannot be blank.'))
      }

      if (!selectedMerchant) {
        reject(Error('Please select Merchant.'))
      }

      if (!startedAt || !endedAt || endedAt < startedAt) {
        reject(Error('Invalid Date Range.'))
      }

      if (!selectedBranchId && !isApplyToAllBranches) {
        reject(Error('Please select Branch.'))
      }

      resolve(true)
    })
  }

  upsertPromotion = async branchId => {
    const { title, startedAt, endedAt, selectedMerchant } = this.state
    const { restaurants, authData, savePromotion, action, promotion } = this.props

    try {
      const promotionRef = firebase.firestore().collection('quantity_promotions')
      const promotionKey = action === 'edit' ? promotion.key : promotionRef.doc().id

      const merchant = restaurants[selectedMerchant]
      const { region } = authData

      const data = {
        title,
        region,
        ended_at: endedAt,
        started_at: startedAt,
        branch_id: branchId,
        merchant_id: selectedMerchant,
        merchant_name: get(merchant, 'name', 'N/A'),
        branch_name: get(merchant, ['branches', branchId, 'name'], 'N/A'),
        updated_at: Number(moment().format('x')),
      }

      if (action === 'new') {
        data.created_at = Number(moment().format('x'))

        await promotionRef.doc(promotionKey).set(data)
      } else {
        await promotionRef.doc(promotionKey).update(data)
      }

      const update = {}

      update[`/restaurants/${selectedMerchant}/branches/${branchId}/quantity_promotion`] = {
        title,
        ended_at: endedAt,
        started_at: startedAt,
      }

      savePromotion({ key: promotionKey, ...data })
      await firebase.database().ref().update(update)
    } catch (error) {
      alert(error.message || error)
    }
  }

  onSave = async () => {
    const { isApplyToAllBranches, selectedBranchId } = this.state
    const { onClose } = this.props

    try {
      await this.validateFields()
      this.setState({ saving: true })

      const branchesWithoutPromotion = this.getBranchesWithoutPromotion()
      const branchIds = isApplyToAllBranches ? map(branchesWithoutPromotion, 'key') : [selectedBranchId]

      branchIds.forEach(async branchId => {
        await this.upsertPromotion(branchId)
      })

      this.setState({ saving: false }, () => onClose())
    } catch(error) {
      this.setState({ saving: false })
      alert(error.message || error)
    }
  }

  getBranchesWithoutPromotion = () => {
    const { selectedMerchant } = this.state
    const { restaurants, quantityPromotions } = this.props

    const restaurant = restaurants[selectedMerchant] || {}
    const promotionBranches = map(quantityPromotions, 'branch_id')

    const branchesWithoutPromotion = reduce(
      restaurant.branches,
      (result, branch, branchKey) => {
        if (!promotionBranches.includes(branchKey)) result.push({ ...branch, key: branchKey })

        return result
      },
      []
    )

    return branchesWithoutPromotion
  }

  render() {
    const { title, isApplyToAllBranches, selectedBranchId, selectedMerchant, startedAt, endedAt, saving } = this.state
    const { restaurants, action, onClose } = this.props;

    const headerName = action === "new" ? "Add New Promotion" : "Edit Quantity Promotion"

    return (
      <Modal open size="small" style={{ marginTop: 0 }}>
        <Header content={headerName} />
        <Modal.Content>
          <Form>
            <Form.Field
              required
              control={Input}
              value={title}
              label="Title"
              onChange={e => this.setState({ title: e.target.value })}
            />

            {action === 'new' ? (
              <Form.Group widths="equal">
                <RestaurantsField
                  value={selectedMerchant}
                  restaurants={restaurants}
                  onChange={value => this.setState({ selectedMerchant: value })}
                />
                <Form.Field
                  style={{ marginTop: 24 }}
                >
                  <Button.Group size="medium">
                    <Button
                      as="a"
                      onClick={() => this.setState({ isApplyToAllBranches: false })}
                      positive={!isApplyToAllBranches}
                    >
                      Apply to branch
                    </Button>
                    <Button.Or />
                    <Button
                      as="a"
                      onClick={() => this.setState({ isApplyToAllBranches: true })}
                      positive={isApplyToAllBranches}
                    >
                      Apply to all branches
                    </Button>
                  </Button.Group>
                </Form.Field>
              </Form.Group>
            ) : null}

            {!isApplyToAllBranches && action === 'new' && (
              <Form.Group widths="equal">
                <BranchesField
                  value={selectedBranchId}
                  allBranches={this.getBranchesWithoutPromotion()}
                  onChange={value => this.setState({ selectedBranchId: value })}
                />
              </Form.Group>
            )}

            <Form.Group widths="equal">
              <DateField
                label="Start Date"
                onChange={value => this.setState({ startedAt: Number( moment(value, 'YYYY-MM-DD').startOf('day').format('x')) })}
                value={startedAt}
              />
              <DateField
                label="End Date"
                onChange={value => this.setState({ endedAt: Number( moment(value, 'YYYY-MM-DD').endOf('day').format('x')) })}
                value={endedAt}
              />
            </Form.Group>
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button floated="left" disabled={saving} onClick={onClose} content='Close' />
          <Button
            color="black"
            content={action === 'new' ? 'Save' : 'Update'}
            icon="checkmark"
            loading={saving}
            disabled={saving}
            onClick={this.onSave}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/promotions/components/QuantityPromotions/Form.js